module.exports = __webpack_public_path__ + "static/img/stylus.3c2e516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stylus.png
// module id = SxCb
// module chunks = 0